import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Contact from '../components/Contact';
import ContactFilterList from '../components/FilterList';
import { visibleContactsSelector } from '../selectors/contacts';
import styles from '../styles/contactList.scss';
import Spinner from './Spinner';
const filters = [
    {
        name: 'Extensions',
        value: 'SHOW_ENDPOINTS',
    },
    {
        name: 'Phonebook',
        value: 'SHOW_PHONEBOOK',
    },
    {
        name: 'All',
        value: 'SHOW_ALL',
    },
];
const ContactList = () => {
    const [expandedId, setExpandedId] = useState('');
    const isFetching = useSelector((state) => state.contacts.isFetching);
    const contacts = useSelector(visibleContactsSelector);
    if (!contacts) {
        return React.createElement("span", null, "Loading contacts");
    }
    return (React.createElement("div", { className: styles.container },
        React.createElement(ContactFilterList, { filters: filters }),
        React.createElement("ul", { className: styles.list },
            contacts.map((contact) => {
                // FIXME guard?
                const number = contact
                    .shortNumber || contact.phoneNumber;
                const expanded = expandedId === contact.id;
                return (React.createElement(Contact, { key: contact.id, name: contact.name, description: number, email: contact.email, id: contact.id, number: number, type: contact.type, status: contact.status, expand: () => {
                        setExpandedId(contact.id);
                    }, collapse: () => {
                        setExpandedId('');
                    }, expanded: expanded, useCallButton: true }));
            }),
            isFetching ? (React.createElement("li", { className: styles.spinner_container },
                React.createElement(Spinner, { text: 'Loading' }))) : (''))));
};
export default ContactList;
